import { createContext } from "react";

interface PaymentContextInterface {
  isPaymentLinkPay?: boolean;
  isFinasticUser?: boolean;
}

export const PaymentContext = createContext<PaymentContextInterface>({});
